import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getPapers({ commit }, {
        paginate = '',
        query = '',
        shouldSavedInStore = true
    } = {}) {
        commit('GET_PAPERS_REQUEST')

        return axios
            .get(`/papers/papers${paginate}${query}`)
            .then(response => {
                if (shouldSavedInStore) commit('GET_PAPERS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PAPERS_FAILURE')
                handleApiError(error, 'Pobranie listy papierów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCertificates({ commit }, {
        paginate = '',
        query = '',
        shouldSavedInStore = true
    } = {}) {
        commit('GET_CERTIFICATES_REQUEST')

        return axios
            .get(`/papers/papers/dicts/paper-certificates${paginate}${query}`)
            .then(response => {
                if (shouldSavedInStore) commit('GET_CERTIFICATES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_CERTIFICATES_FAILURE')
                handleApiError(error, 'Pobranie listy certyfikatów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCoatingTypes({ commit }) {
        return axios
            .get('/papers/papers/dicts/paper-coating-types')
            .then(response => {
                commit('GET_COATING_TYPES', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie rodzajów powleczenia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getPrinergyPaperTypes({ commit }) {
        return axios
            .get('/papers/papers/dicts/prinergy-paper-types')
            .then(response => {
                commit('GET_PRINERGY_PAPER_TYPES', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów prinergy dla papierów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createPaper({ commit }, paperData) {
        return axios
            .post('/papers/papers', paperData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Papier został dodany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie papieru nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updatePaper({ commit }, paperData) {
        return axios
            .patch(`/papers/papers/${paperData.id}`, paperData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Papier został zedytowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja papieru nie powiodła się.')

                return Promise.reject(error)
            })
    },
    generatePapersPriceList({ commit }, {
        userEmail
    } = {}) {
        return axios
            .post('/papers/export-papers', {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Cennik papierów został wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie cennika nie powiodło się.')

                return Promise.reject(error)
            })
    },
    importPapersPriceList({ commit, state }, { formData, abort}) {
        if (!abort) {
            const cancelToken = axios.CancelToken
            const cancelTokenSource = cancelToken.source()

            commit('SET_CANCEL_TOKEN', cancelTokenSource)
        } else {
            state.cancelToken.cancel('canceled')

        }

        commit('FILE_PROGRESS', {
            show: true,
            value: 0
        }, { root: true })

        return axios
            .post('/papers/import-papers', formData, {
                cancelToken: state.cancelToken.token,
                timeout: 900000, // 15 min
                onUploadProgress(progressEvent) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)

                    commit('FILE_PROGRESS', {
                        show: false,
                        value: percentCompleted
                    }, { root: true })
                }
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Plik został wysłany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                if (error.message !== 'canceled') {
                    handleApiError(error, 'Wysłanie pliku nie powiodło się.')

                    return Promise.reject(error)
                }
            })
            .finally(() => {
                commit('SET_CANCEL_TOKEN', null)
                commit('FILE_PROGRESS', {
                    show: false,
                    value: 0
                }, { root: true })
            })
    },
    setPapersFilters({ commit }, filters) {
        commit('SET_PAPERS_FILTERS', filters)
    },
    clearPapersFilters({ commit }) {
        commit('CLEAR_PAPERS_FILTERS')
    }
}